export const ARTICLES = [
  {
    label: 'HELP_DRAWER_ARTICLE_1',
    action:
      'https://ayuda.crehana.com/es/articles/6064197-soy-administrador-como-subo-usuarios-a-crehana',
  },
  {
    label: 'HELP_DRAWER_ARTICLE_2',
    action:
      'https://ayuda.crehana.com/es/articles/6064201-soy-administrador-como-gestionar-usuarios',
  },
  {
    label: 'HELP_DRAWER_ARTICLE_3',
    action:
      'https://ayuda.crehana.com/es/articles/6064167-soy-administrador-crear-atributos',
  },
  {
    label: 'HELP_DRAWER_ARTICLE_4',
    action:
      'https://ayuda.crehana.com/es/articles/6064158-soy-administrador-como-veo-el-rendimiento-de-mis-atributos',
  },
];

export const HELP_URL =
  'https://ayuda.crehana.com/es/collections/3387926-educacion#crehana-para-empresas';

export const CONTACT_URL = 'https://ayuda.crehana.com/';

export const FEEDBACK_URL = 'https://crehana.canny.io/feedback';
